import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// 类型定义
export interface GameSave {
  id: string
  user_id: string
  slot_number: number
  save_name: string
  play_time_seconds: number
  current_year: number
  current_month: number
  preview: {
    countryName?: string
    totalPopulation?: number
    totalMoney?: number
    talentCount?: number
  }
  game_data: Record<string, unknown>
  version: number
  created_at: string
  updated_at: string
}
